<script lang="ts" setup>
import AppStore from './AppStore.vue'
import GooglePlay from './GooglePlay.vue'
import LaunchWebApp from './LaunchWebApp.vue'

const { t } = useI18n()
</script>

<template>
  <div
    class="join-revolution min-h-182.5 max-w-237.25 mx-5 pb-35.5 lg:w-full lg:mx-auto lg:mt-17.5 lg:h-154.5 xl:mx-auto xl:max-w-309"
  >
    <p
      class="text-2xl tracking-wide text-[#7540EE] text-center mt-15 max-w-90 md:max-w-full md:text-[1.75rem] md:tracking-wider lg:mt-24"
    >
      {{ t('start-building-your-monetized-community-today') }}
    </p>
    <div
      class="text-center text-lg leading-normal tracking-[0.0375rem] mt-3.5 lg:mt-9.5"
    >
      <p
        class="mb-5.5 px-5 max-w-87 mx-auto sm:max-w-192 lg:max-w-178.5 lg:px-0 lg:mb-6"
      >
        {{
          t(
            'dont-miss-the-opportunity-to-revolutionize-your-community-with-belong-our-platform-offers-seamless-integration-innovative-features-and-multiple-revenue-streams-whether-its-online-or-physical-spaces-private-chats-or-exclusive-events-belong-is-your-partner-in-community-growth-and-monetization'
          )
        }}
      </p>

      <div
        class="hidden max-w-98 text-center text-base sm:max-w-130 sm:mx-auto lg:flex lg:flex-col"
      >
        <NuxtLink
          target="_blank"
          to="https://app.belong.net"
          class="hidden lg:flex rounded-full border border-[#FFB0F0] text-[#FFB0F0] h-10 bg-[#000] py-1.5 pl-6 pr-5 mx-auto mb-5"
        >
          {{ t('join-belong-now') }}
        </NuxtLink>
        <p>
          {{
            t(
              'and-take-the-first-step-towards-transforming-your-community-into-a-thriving-revenue-generating-ecosystem'
            )
          }}
        </p>
      </div>

      <div
        class="pl-2.5 pr-5 max-w-98 text-center sm:max-w-130 sm:mx-auto lg:hidden"
      >
        <NuxtLink
          target="_blank"
          to="https://app.belong.net"
          class="rounded-full border border-[#FFB0F0] w-33.5 h-10 bg-[#000] pr-2.5 pl-2 py-1.5 mr-3.5 text-[#FFB0F0]"
        >
          {{ t('join-belong') }}
        </NuxtLink>
        <span>
          {{
            t(
              'now-and-take-the-first-step-towards-transforming-your-community-into-a-thriving-revenue-generating-ecosystem'
            )
          }}
        </span>
      </div>
      <div
        class="hidden flex-row items-center justify-center mt-7 gap-5.5 flex-wrap lg:flex"
      >
        <AppStore />
        <GooglePlay />

        <LaunchWebApp />
      </div>
    </div>
  </div>
</template>

<style scoped>
.join-revolution {
  @apply min-h-61.25 flex flex-col items-center justify-start rounded-[1.25rem] sm:px-0;
  background: url(~/assets/images/mighty-networks-alternative/start-building.svg);
  background-size: cover;
  background-position: center;
}

@media (min-width: 1024px) {
  .join-revolution {
    background: url(~/assets/images/mighty-networks-alternative/start-building-desktop.svg);
  }
}
</style>
